export default function SubItemController(
  $q,
  serviceIds,
) {
  const vm = this;

  // Set Default Values
  vm.serviceId = serviceIds.oversight;
  vm.canExpand = vm.status !== 'No Agenda Item Added';
  vm.isExpanded = false;
  /*  vm.canAddItemNote = (vm.finding.canAddNote || vm.finding.isAssignedToMe) && vm.auditIsActive;
  vm.canAttachItemItems = (vm.finding.canAttachItems || vm.finding.isAssignedToMe) && vm.auditIsActive;
  vm.canChangeItemStatus = (vm.finding.canChangeStatus || vm.finding.isAssignedToMe || vm.finding.canEdit)
    && vm.finding.statusId !== 3
    && vm.auditIsActive;
  vm.canEditItem = vm.finding.canEdit && vm.auditIsActive;
  vm.canDeleteItem = vm.finding.canDelete && vm.auditIsActive; */

  // Attach Event Handlers
  vm.handleExpandSubItem = _handleExpandSubItem;
  /* vm.handleEditFinding = _handleEditFinding;
  vm.handleDeleteFinding = _handleDeleteFinding;
  vm.handleAddFindingNote = _handleAddFindingNote;
  vm.handleMarkStatusComplete = _handleMarkStatusComplete;
  vm.handleAttachItems = _handleAttachItems;
  vm.documentAttached = _documentAttached;
  vm.handleConfirmDelete = _handleConfirmDelete;
  vm.handleCancelDelete = _handleCancelDelete;
  vm.handleConfirmComplete = _handleConfirmComplete;
  vm.handleCancelComplete = _handleCancelComplete; */

  _activate();

  // //////// METHODS //////////

  // _initEventListeners();


  function _activate() {
    const dfdActivate = $q.defer();
    return dfdActivate.resolve(false);
    /* _refreshBusinessRisks().then(
      _refreshTechnicalRisks().then(
        _refreshPriorities().then(
          _refreshFindingStatuses().then(
            _refreshUsers().then(dfdActivate.resolve)
          )
        )
      )
    ); */
  }

  function _handleExpandSubItem() {
    vm.isExpanded = !vm.isExpanded;

    /* if (vm.isExpanded) {
      _refreshFinding();
    } */
  }
}

SubItemController.$inject = [
  '$q',
  'serviceIds',
];
